import * as React from 'react';
export var defaultFormContextProps = {
  layout: 'inline',
  size: 'medium'
};
var FormContext = React.createContext(defaultFormContextProps);
export default FormContext;